<div class="side-drawer__header">
  <div class="side-drawer__header__title">
    {{ getActionString() }}
    <carrier-logo
      *ngIf="chosenCarrierType || currentCarrier"
      size="small"
      [carrierName]="chosenCarrierType?.name || currentCarrier?.type?.name"></carrier-logo>
  </div>

  <div class="side-drawer__header__close-btn" (click)="onClose()">
    <img
      class="margin-auto"
      src="assets/icons/x-delivery-services.svg"
      alt=""
      matTooltip="Close"
      matTooltipClass="pdq-mat-tooltip" />
  </div>
</div>
<div>
  <div [ngSwitch]="state">
    <div *ngSwitchCase="STATE.CHOOSE_CARRIER">
      <app-choose-carrier (onOpenCarrier)="onOpenCarrier($event)"> </app-choose-carrier>
    </div>
    <div *ngSwitchCase="STATE.CREATE_CARRIER">
      <div class="side-drawer__comp">
        <app-create-carrier
          [carrierType]="chosenCarrierType"
          [drawer]="drawer"
          [shopID]="shopId"
          (isPending)="isPending($event)"
          (closeAfterAction)="closeAfterAction()"></app-create-carrier>
      </div>
    </div>

    <div *ngSwitchCase="STATE.EDIT_CARRIER">
      <div class="side-drawer__comp">
        <app-edit-carrier
          [editableCarrierType]="currentCarrier.type"
          [shopID]="shopId"
          (isPending)="isPending($event)"
          [editableCarrierID]="currentCarrier.id"
          (closeAfterAction)="closeAfterAction()"></app-edit-carrier>
      </div>
    </div>

    <div *ngSwitchCase="STATE.DUPLICATE_CARRIER">
      <div class="side-drawer__comp">
        <app-edit-carrier
          [duplicateMode]="true"
          [editableCarrierType]="currentCarrier.type"
          [shopID]="shopId"
          (isPending)="isPending($event)"
          [editableCarrierID]="currentCarrier.id"
          (closeAfterAction)="closeAfterAction()"></app-edit-carrier>
      </div>
    </div>

    <div
      class="side-drawer__actions"
      *ngIf="state !== 'chooseCarrier'"
      [ngClass]="
        (state === 'editCarrier' && !isChosenCarrierSupportsExternalAuth) || state === 'duplicateCarrier'
          ? 'end-flex'
          : ''
      ">
      <pdq-button
        icon="back"
        *ngIf="state === 'createCarrier'"
        (onClick)="onBackToList()"
        variant="ghost"
        label="Back to list">
      </pdq-button>

      <div *ngIf="state === 'editCarrier' && isChosenCarrierSupportsExternalAuth">
        <pdq-checkbox
          [labelSize]="'tiny'"
          [checked]="false"
          (onChange)="onSetReauthenticateMode($event)"
          [label]="'Reauthenticate upon save'"></pdq-checkbox>
      </div>

      <div class="side-drawer__actions-btns">
        <pdq-button (onClick)="onClose()">Cancel</pdq-button>
        <pdq-button
          variant="primary"
          [loading]="isCreatingCarrier"
          [label]="buttonActionText + ' delivery service'"
          (onClick)="onSubmit()">
        </pdq-button>
      </div>
    </div>
  </div>
</div>
